<template>
    <v-virtual-scroll @scroll="onScroll" :id="`giver-scroll-${itemId}`" v-if="givers && itemId && length" :items="givers" :item-height="$mobile ? 25 : 50" :bench="length" :height="$mobile ? 20 : 100">
        <template v-slot:default="{ item, index }">
            <v-list-item v-show="show">
                <v-list-item-avatar>
                    <v-avatar v-show="item.name !== ''" :color="item.color" :size="$mobile ? 18 : 56" class="white--text">
                        {{ item.initials }}
                    </v-avatar>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>
                        <span :class="$mobile ? 'text-subtitle-2' : ''" :id="`scrollTo-${index}`" v-html="item.name"></span>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-virtual-scroll>
</template>
<style scoped>
.v-virtual-scroll {
    overflow-y: hidden;
}
</style>
<script>
import goTo from 'vuetify/lib/services/goto';

export default {
    name: 'BnftGiverScroll',
    props: {
        uniqueItemId: Object,
        owner: String,
    },
    data: function () {
        return {
            colors: [
                '#2196F3',
                '#90CAF9',
                '#64B5F6',
                '#42A5F5',
                '#1E88E5',
                '#1976D2',
                '#1565C0',
                '#0D47A1',
                '#82B1FF',
                '#448AFF',
                '#2979FF',
                '#2962FF',
            ],
            givers: null,
            interval: null,
            options: {
                easing: 'easeInOutCubic',
                duration: 4500,
            },
            show: true,
            offsetTop: 0,
        };
    },
    computed: {
        itemId() {
            return this.uniqueItemId?.item_id;
        },
        length() {
            return this.givers?.length;
        },
    },
    watch: {
        offsetTop(value) {
            if (value === 0) {
                this.show = true;
            }
        }
    },
    methods: {
        onScroll(e) {
            this.offsetTop = e.target.scrollTop;
        },
        autoScroll() {
            const { options } = this;
            let self = this;
            let scrolltoIndex = 0;
            let scrolltoEnd = this.givers.length;
            this.interval = setInterval(() => {
                if (scrolltoIndex + 1 >= scrolltoEnd) {
                    scrolltoIndex = 0;
                    self.show = false;
                    goTo(`#scrollTo-${scrolltoIndex}`, {
                        container: `#giver-scroll-${this.itemId}`,
                    });
                } else {
                    scrolltoIndex++;
                    goTo(`#scrollTo-${scrolltoIndex}`, {
                        container: `#giver-scroll-${this.itemId}`,
                        ...options,
                    });
                }
            }, 5000);
        },
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    mounted() {
        const self = this;
        (async () => {
            self.givers = await self.$near.wishlist({
                functionName: 'givers_per_item',
                contractArgs: {
                    id: self.uniqueItemId,
                },
            });
            self.givers = ['']
                .concat(self.givers, [
                    `Support ${this.owner.match(/[^\s]*/)}!`,
                    `Give and earn at the same time!`,
                    `Giving supports breast health organizations.<sup><a target="_blank" rel="noopener" style="text-decoration: none" href="https://branfts.com/faq?id=622129ce1416900001d55656">(How?)</a></sup>`,
                    `Your name goes here when you give.`,
                    '',
                    '',
                    `Give the gift of supported breasts today.`,
                    '',
                    '',
                ])
                .map((giver, index) => ({
                    name: giver,
                    initials: giver.match(/_(.)([^-]*)-(.)/)
                        ? giver.match(/_(.)([^-]*)-(.)/)[1] +
                          giver.match(/_(.)([^-]*)-(.)/)[3]
                        : '=)',
                    color: self.colors[index % 12],
                }));
            self.autoScroll();
        })();
    },
};
</script>
